import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import useStatic from '@hooks/useStatic'
import React from 'react'
import { useState } from 'react'

export default function ClubDelivery({ club }: Props) {
    const [address, setAddress] = useState(Boolean(club?.address))

    const toggleAddress = useStatic<
        React.ChangeEventHandler<HTMLInputElement>
    >(e => setAddress(e.target.checked))

    return (
        <Grid gap="20px">
            <div>
                <h3>Delivery</h3>
                <p>We can send all of the awards gained by the group's members in one package</p>
            </div>
            <Input 
                id="is_postal" 
                name="is_postal" 
                type="checkbox" 
                label="Send all awards to a single address." 
                comment="We can send all awards gained by the group's members to this address." 
                checked={Boolean(club?.address)} 
                onChange={toggleAddress} />
            <Input id="address" name="address" label="Address" placeholder="France, Paris, 92 Place de la Madeleine" disabled={!address} defaultValue={club?.address} />
            <Input id="zip" name="zip" label="ZIP Code" disabled={!address} defaultValue={club?.zip} placeholder="75011" />
        </Grid>
    )
}

interface Props {
    club?: Resources.Club
}